
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-agent-toolkit",
      function () {
        return require("private-next-pages/home-agent-toolkit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-agent-toolkit"])
      });
    }
  